import type { SVGProps } from "react";

export const AttachmentIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
		<path
			fill="currentColor"
			d="M18.2,41c-2.1,0-4.4-0.7-6.8-2.6c-2.6-2-4-4.4-4.4-7.1c-0.6-4.5,2.3-8.3,2.4-8.4L21.4,7.7 c0.7-0.9,1.9-1,2.8-0.3s1,1.9,0.3,2.8L12.7,25.4c-0.4,0.6-4.2,5.7,1.2,9.9c5.4,4.2,9.5-0.7,10-1.3l14.3-18.3 c0.6-0.8,2.2-3.4-0.7-5.7c-3.1-2.4-5.5,0.4-5.8,0.7L17.5,29c-0.6,0.8-0.1,1.3,0.2,1.5c0.2,0.2,0.8,0.6,1.5-0.2l12.7-16.4 c0.7-0.9,1.9-1,2.8-0.4c0.9,0.7,1,1.9,0.4,2.8L22.3,32.8c-1.2,1.6-4.2,3.1-7.1,0.9c-1.6-1.2-2.3-2.9-1.9-4.8c0.2-1.2,0.9-2.1,1-2.3 L28.5,8.2c2-2.6,6.7-5,11.4-1.4c2.6,2,3.6,4.7,3.1,7.6c-0.4,2.1-1.5,3.5-1.6,3.7L27,36.5C25.5,38.5,22.2,41,18.2,41z"
		/>
	</svg>
);
